import { illegalityData } from '../utils'
// 美元/人民币
export function createUsdRmbCharts({unit_legend, x_labels, unit, values_hash = {}, color = [], title} = {}) {
    const usd = values_hash.usd || []
    const rmb = values_hash.rmb || []
    return {
        title: {
            text: title,
            left: 'center',
            top: 0,
        },
        color,
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            show: true,
            right: 0,
        },
        grid: {
            top: 80,
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: x_labels,
            axisLine: {
                onZero: false,
                lineStyle: {
                    opacity: 0.4
                }
            },
            minorTick: {
                show:false
            },
            minorSplitLine: {
                show:false
            },
            splitLine: {
                show: false
            },
        },
        yAxis: {
            type: 'value',
            name: unit_legend,
            nameTextStyle: {
                color: '#9a9a9a',
                align: 'right',
            },
            axisLine: {
                show: false
            }
        },
        series: [
            {
                name: '美元',
                type: 'bar',
                barWidth: 15,
                barGap: 0,
                 data: usd.map(v => {
                    if (illegalityData(v)) {
                        return ''
                    }
                    return (v / unit).toFixed(2)
                }),
            },
            {
                name: '人民币',
                type: 'bar',
                barWidth: 15,
                data: rmb.map(v => {
                    if (illegalityData(v)) {
                        return ''
                    }
                    return (v / unit).toFixed(2)
                }),
            },
        ]
    }
}

// 资金余额变动
export function createZXCharts({title, seriesName, unit, unit_legend, x_labels, values, color}) {
    return {
        title: {
            text:title,
            left: 'center',
        },
        color,
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            show: false,
        },
        grid: {
            left: '4%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: x_labels,
            
            axisLine: {
                onZero: false,
                lineStyle: {
                    opacity: 0.4
                }
            },
            minorTick: {
                show:false
            },
            minorSplitLine: {
                show:false
            },
            splitLine: {
                show: false
            },
        },
        yAxis: {
            type: 'value',
            name: unit_legend,
            nameTextStyle: {
                color: '#9a9a9a',
                align: 'right',
            },
            axisLine: {
                show: false
            }
        },
        series: [
            {
                name:seriesName,
                type: 'line',
                symbol: 'emptyCircle',
                symbolSize: 7,
                emphasis: {
                    focus: 'series'
                  },
                // xAxisIndex: 1,
                data: values && values.map(v => {
                    if (illegalityData(v)) {
                        return ''
                    }
                    return (v / unit).toFixed(2)
                }),
            },
        ]
    }
}

// 汇兑损益变动 ｜ 现金流入流出变动
export function createhdsyCharts({title, seriesName, unit, unit_legend, x_labels, values, color}) {
    return {
        title: {
            text:title,
            left: 'center',
        },
        color,
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            show: false,
        },
        grid: {
            left: '6%',
            right: '4%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
            data: x_labels,
            type: 'category',
            axisLine: { show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
        },
        yAxis: {
            type: 'value',
            name: unit_legend,
            nameTextStyle: {
                color:  '#9a9a9a',
                align: 'right',
                // nameLocation: "center",
            },
            axisLine: {
                show: false
            }
        },
        series: [
            {
                name:seriesName,    
                type: 'bar',
                emphasis: {
                    focus: 'series'
                  },
                  barWidth: 25,
                // xAxisIndex: 1,
                label: {
                    show: true,
                    formatter: '{b}',
                    color: '#9a9a9a'
                },
                data: values && values.map(v => {
                    if (illegalityData(v)) {
                        return ''
                    }
                    const value = Number((v / unit).toFixed(2))
                    return {
                        value,
                        itemStyle: {
                            color: value < 0 ? '#FFB3B3' : '#7EE697'
                        },
                        label: {
                             position:value < 0 ? 'top' : 'bottom',
                        }
                    }
                }),
            },
        ]
    }
}
